<template>
        <form class="" :class="{ 'is-loading': isLoading }" ref="location-selector-form" @submit.prevent="handleSubmit" novalidate>
            <div class="form-group">
                <div role="alert" class="alert alert-danger">
                    Form error message
                </div>
            </div>
            <div class="row">
                <div class="form-group col-lg-4">
                    <label :for="inputLabel">{{ translations.searchLabel }}</label>
                    <input :id="inputLabel" name="hospital" type="text" ref="input1" class="form-control" v-model="hospital" :placeholder="translations.searchLabelPlaceholder">
                </div>
                <div class="form-group col-lg-1 p-0">
                    <span class="c-ce-search__orlabel">or</span>
                </div>
           
                
                <div class="form-group col-lg-4">
                    <label :for="inputAddressLabel">{{ translations.searchAddressLabel }}</label>
                    <input :id="inputAddressLabel" name="address" type="text" ref="input2" autocomplete="off" class="form-control" v-model="address" :placeholder="translations.addressLabelPlaceholder"/>
                </div>

                <div class="form-group col-lg-3">
                    <label :for="distanceId">{{ translations.distance }}</label>

                    <select class="custom-select btn--select form-control" :id="distanceId" name="distance" v-model="distance">
                        <option value="">{{ translations.distancePlaceholder }}</option>
                        <option v-for="distance in distances" :value="distance.code" :key="distance.code">{{ distance.title }}</option>
                    </select>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-4">
                    <button class="c-map-search__search-btn btn btn-danger btn-round" :disabled="!validInput" ref="submit" type="submit">{{ translations.search }}</button>
                </div>
            </div>
        </form>
</template>

<script>
    

    import axios from 'axios';

    export default {
        data() {
            return {
                searchLabelPlaceholder: '',
                hospital: '',
                distance: '',
                address: '',
                distancePlaceholder: '',
                isLoading: false,
                inputLabel: null,
                inputAddressLabel: null,
                distanceId: null
            };
        },
        mounted() {
            this.inputLabel = "hospital_" + this._uid;
            this.inputAddressLabel = "address_" + this._uid;
            this.distanceId = "distance_" + this._uid;
        },
        props: {
            isVisible: {
                type: Boolean,
                default: false
            },
            onSubmit: {
                type: Function
            },
            translations: {
                type: Object,
                required: true
            },
            endpoint: {
                type: String,
                required: true
            },
            distances: {
                type: Array
            }
        },
        computed: {
            validInput() {
                return this.address !== '' || this.hospital !== '';
            }
        },
        watch: {
            isVisible: function(val) {
                if(val) {
                    this.focusRef(this.$refs.input1);
                }
            }
        },
        methods: {
            handleSubmit() {
                this.isLoading = true;

                axios.post(this.$props.endpoint, {
                    search: this.address || this.hospital
                })
                .then(response => {
                    this.isLoading = false;

                    // Pass the data back to the parent component
                    this.onSubmit({
                        searchText: this.address || this.hospital,
                        locations: response.data
                    });

                    this.address = '';
                    this.hospital = '';

                    // Scroll on submit
                    let target = document.getElementsByClassName('l-article__col')[0];
                    let scrollContainer = target;
                    console.log("this is target",target);

                    if (target) {
                        do { //find scroll container
                            scrollContainer = scrollContainer.parentNode;
                            if (!scrollContainer) return;
                            scrollContainer.scrollTop += 1;
                        } while (scrollContainer.scrollTop == 0);

                        let targetY = 0;
                        do { //find the top of target relatively to the container
                            if (target == scrollContainer) break;
                            targetY += target.offsetTop;
                        } while (target = target.offsetParent);

                        scroll = function(c, a, b, i) {
                            i++; if (i > 30) return;
                            c.scrollTop = a + (b - a) / 30 * i;
                            setTimeout(function(){ scroll(c, a, b, i); }, 20);
                        }
                        // start scrolling
                        scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
                    }
                    

                }).catch(error => {
                    this.isLoading = false;
                });
            },
            focusRef(ref) {
                this.$nextTick(() => {
                    this.$nextTick(() => {
                        (typeof ref.$el !== 'undefined' ? ref.$el : ref).focus();
                    });
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// demo/components/map-search.vue